/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Translation = {
    properties: {
        textDE: {
            type: 'string',
            isRequired: true,
        },
        textIT: {
            type: 'string',
            isRequired: true,
        },
        textEN: {
            type: 'string',
            isRequired: true,
        },
        text: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        id: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
